import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { cn } from '@/lib/utils';
import { Form, Formik } from 'formik';
import React from 'react';
import { FooterElementDataType } from './types';

type FormValues = {
  email?: string;
};

const initialValues = {
  email: '',
  twitterUrl: '',
  facebookUrl: '',
  instagramUrl: '',
  youtubeUrl: '',
  tiktokUrl: '',
} as FormValues;

export default function ElementContent({ element, preview }: ElementProps) {
  const content = element.data as FooterElementDataType;

  const childs = element.childs;

  const gridColumns = React.useCallback(
    (limit: number) => {
      switch (limit) {
        case 3:
          return 'md:grid-cols-3';
        case 4:
          return 'md:grid-cols-4';
        case 5:
          return 'md:grid-cols-5';

        default:
          // empty
          break;
      }
    },
    [content.limit]
  );

  return (
    <>
      <section className='scheme_footer'>
        <div className='w-full border-t' style={{ marginTop: `${content.topMargin}px` }}>
          <div
            className={cn(
              'footer_wrapper theme_layout_page_width mx-auto w-full py-8 duration-100'
            )}
          >
            <div className='px-10'>
              <Formik initialValues={initialValues} onSubmit={() => alert('submit')}>
                {({ handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className={`grid gap-1 gap-y-4 ${gridColumns(content?.limit || 3)}`}>
                      {childs?.map((c) => (
                        <div key={c.id}>
                          <WrapperChild
                            child={{ ...c, parentData: content }}
                            parentType={element.type}
                            key={c.id}
                            className='flex h-full w-full items-start p-3 text-left'
                            preview={preview}
                          />
                        </div>
                      ))}
                    </div>
                    {/* <div
                      className={cn(
                        'w-full lg:flex',
                        content.isShowEmailSignUp && isShowSocialMedia
                          ? 'justify-between'
                          : 'justify-center'
                      )}
                    > */}
                    {/* temporary hide */}
                    {/* {content.isShowEmailSignUp && (
                        <div className='w-full lg:w-1/2'>
                          <div
                            className={cn('mb-4 mt-6 flex', !isShowSocialMedia && 'justify-center')}
                            dangerouslySetInnerHTML={{ __html: content.headingEmailSignUp || '' }}
                          ></div>
                          <div
                            className={cn('flex w-full', !isShowSocialMedia && 'justify-center')}
                          >
                            <FormItem className='mb-4 text-sm lg:w-1/2'>
                              <FormControl>
                                <Input
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                  name='email'
                                  type='text'
                                  size={100}
                                  placeholder='Email'
                                />
                              </FormControl>
                              <FieldErrorMessage className='text-left' error={errors.email} />
                            </FormItem>
                          </div>
                        </div>
                      )} */}
                    {/* {isShowSocialMedia && (
                        <div
                          className={cn(
                            'mt-4 flex w-full items-center space-x-3 lg:w-1/2',
                            !content.isShowEmailSignUp ? 'justify-center' : 'lg:justify-end'
                          )}
                        >
                          {content.twitterUrl && (
                            <Link href={content.twitterUrl}>
                              <TwitterIcon />
                            </Link>
                          )}
                          {content.facebookUrl && (
                            <Link href={content.facebookUrl}>
                              <FacebookIcon />
                            </Link>
                          )}
                          {content.instagramUrl && (
                            <Link href={content.instagramUrl}>
                              <InstagramIcon />
                            </Link>
                          )}
                          {content.youtubeUrl && (
                            <Link href={content.youtubeUrl}>
                              <YoutubeIcon />
                            </Link>
                          )}
                          {content.tiktokUrl && (
                            <Link href={content.tiktokUrl}>
                              <TiktokIcon />
                            </Link>
                          )}
                        </div>
                      )} */}
                    {/* </div> */}
                  </Form>
                )}
              </Formik>
            </div>
            {/* <div className='w-full px-10 pt-6 mt-6 border-t lg:px-14'>
              <div className='flex justify-center mx-auto duration-100 theme_layout_page_width'>
                <small>
                  © 2024,{' '}
                  <a href='/' title=''>
                    {storeId}
                  </a>
                </small>
                <small>
                  <a target='_blank' rel='nofollow' href='#'>
                    Powered by Jubelio
                  </a>
                </small>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .scheme_footer {
            background-color: ${content.colorSchemeFooter?.background || 'white'};
            color: ${content.colorSchemeFooter?.text || '#52535B'} !important;
          }
          .footer_wrapper {
            padding-top: ${content.topPadding}px;
            padding-bottom: ${content.bottomPadding}px;
          }
          .heading_contact_form {
            color: ${content.colorSchemeFooter?.text || '#52535B'} !important;
          }
        `}
      </style>
    </>
  );
}
